import styled from "@emotion/styled";

const StyledSalesLandingTextBlock = styled.div`
  background-color: ${({ theme }) => theme.colors.tone.white};
  color: ${({ theme }) => theme.colors.tone.black};
  width: 100%;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  letter-spacing: 1.6px;
`;

export { StyledSalesLandingTextBlock };
